import { z } from "zod";

import { externalIntegrationSchema } from "./external-integration-schema";
import { externalManagedConfigurationSchema } from "./external-managed-configuration-schema";

export const securePrintConfigurationSchema = z.object({
	tenantId: z.string(),
	updateAt: z.string(),
	externalManaged: externalManagedConfigurationSchema,
	customerManaged: externalIntegrationSchema,
	daysToLive: z.number().nullable().optional(),
});

export type SecurePrintConfiguration = z.infer<typeof securePrintConfigurationSchema>;
